import {HStack, Text} from 'platform/foundation';
import {match} from 'ts-pattern';

import {type RequiredTestIdProps, suffixTestId} from 'shared/web';

import type {AbcXyzLegendItem} from '../types/AbcXyzLegendItem';

const SWATCH_SIZE = 12;
const SWATCH_CENTER = SWATCH_SIZE / 2;
const LINE_WIDTH = 2;
const DASH_PATTERN = '3 2';

interface AbcXyzChartLegendProps extends RequiredTestIdProps {
  items: AbcXyzLegendItem[];
}

export function AbcXyzChartLegend(props: AbcXyzChartLegendProps) {
  return (
    <HStack spacing={3} align="center">
      {props.items.map((item) => (
        <HStack key={item.id} spacing={1} align="center">
          <svg width={SWATCH_SIZE} height={SWATCH_SIZE} aria-hidden>
            {match(item.shape)
              .with('bar', () => (
                <rect width={SWATCH_SIZE} height={SWATCH_SIZE} rx={2} fill={item.color} />
              ))
              .with('line', () => (
                <line
                  x1={0}
                  x2={SWATCH_SIZE}
                  y1={SWATCH_CENTER}
                  y2={SWATCH_CENTER}
                  stroke={item.color}
                  strokeWidth={LINE_WIDTH}
                />
              ))
              .with('dashedLine', () => (
                <line
                  x1={0}
                  x2={SWATCH_SIZE}
                  y1={SWATCH_CENTER}
                  y2={SWATCH_CENTER}
                  stroke={item.color}
                  strokeWidth={LINE_WIDTH}
                  strokeDasharray={DASH_PATTERN}
                />
              ))
              .exhaustive()}
          </svg>
          <Text
            size="xSmall"
            color="secondary"
            data-testid={suffixTestId(`legend-${item.id}`, props)}
          >
            {item.label}
          </Text>
        </HStack>
      ))}
    </HStack>
  );
}
